import { lazy } from 'react';
export const routes = [
    // Section divider for OEE
    {
        label: '__SECTION__',
        path: '__OEE_SECTION__',
        element: lazy(() => import('../pages/Dashboard/Dashboard')),
        sectionTitle: 'OEE',
        hidden: false,
    },
    // OEE items
    {
        label: 'Dashboard',
        path: '/',
        element: lazy(() => import('../pages/Dashboard/Dashboard')),
        description: 'Main dashboard overview',
    },
    {
        label: 'OEE Overview',
        path: '/oee-dashboard',
        element: lazy(() => import('../pages/OeeDashboard')),
        description: 'Overall equipment effectiveness dashboard',
    },
    {
        label: 'Production',
        path: '/production-output',
        element: lazy(() => import('../pages/ManualCount/OEEQualityList')),
        description: 'Track production output and quality',
    },
    {
        label: 'Downtime',
        path: '/downtime-events',
        element: lazy(() => import('../pages/DowntimeEvents')),
        description: 'View downtime events and analysis',
    },
    {
        label: 'Alerts',
        path: '/alert-management',
        element: lazy(() => import('../pages/AlertManagementPage')),
        description: 'Monitor and manage alerts',
    },
    {
        label: 'Line Activity',
        path: '/profile-stats',
        element: lazy(() => import('../pages/Profiles/ProfileStatsPage')),
        description: 'Per-line recipe timeline, utilisation, audit log',
    },
    {
        label: 'Drift Review',
        path: '/profile-stats/drift',
        element: lazy(() => import('../pages/Profiles/DriftFlagsPage')),
        description: 'Sensors whose baseline has shifted — weekly drift report',
    },
    {
        label: 'Recalculate',
        path: '/oee-summary-admin',
        element: lazy(() => import('../pages/OEESummaryAdmin')),
        description: 'Re-run OEE calculation jobs',
    },
    {
        label: 'Email Alerts',
        path: '/email-management',
        element: lazy(() => import('../pages/EmailManagement')),
        description: 'Manage SNS email recipients for alert notifications',
    },
    {
        // kept hidden — BE still wired; bookmarks still work
        label: 'WhatsApp Management',
        path: '/whatsapp-management',
        element: lazy(() => import('../pages/WhatsAppManagement')),
        description: 'Manage WhatsApp notifications',
        hidden: true,
    },
    // User Management (Admin only)
    {
        label: 'Users',
        path: '/settings/users',
        element: lazy(() => import('../pages/UsersSettingsPage')),
        description: 'Manage user accounts and permissions (Admin only)',
        hidden: false,
    },
    // OEE Setup (formerly Settings)
    {
        label: 'Setup',
        path: '/settings',
        element: lazy(() => import('../pages/Settings')),
        subItems: [
            {
                label: 'Production Lines',
                path: '/settings/device-groups',
                element: lazy(() => import('../pages/Settings/DeviceGroupsPage')),
                description: 'Organize devices into groups',
            },
            {
                label: 'Device Settings',
                path: '/settings/devices',
                element: lazy(() => import('../pages/Settings')),
                description: 'Configure device settings',
            },
            {
                label: 'Sensor Types',
                path: '/settings/sensor-types',
                element: lazy(() => import('../pages/Settings/SensorTypesPage')),
                description: 'Manage sensor type configurations',
            },
            {
                label: 'OEE Products',
                path: '/settings/oee-products',
                element: lazy(() => import('../pages/ManualCount/OEEProductList')),
                description: 'Manage product definitions',
            },
        ],
    },
    // Section divider for Inventory Management
    {
        label: '__SECTION__',
        path: '__INVENTORY_SECTION__',
        element: lazy(() => import('../pages/InventoryManagement')),
        sectionTitle: 'Inventory Management',
        hidden: false,
    },
    // Inventory Management items — ordered catalog → operations → attention → insights → reports
    {
        label: 'Raw Materials',
        path: '/inventory-management/raw-materials',
        element: lazy(() => import('../pages/inventory/RawMaterialsPage')),
        description: 'Manage raw materials inventory',
    },
    {
        label: 'Stock Movement',
        path: '/inventory-management/stock-movement',
        element: lazy(() => import('../pages/inventory/StockMovementPage')),
        description: 'Track stock movements and transfers',
    },
    {
        label: 'Stock Movement Details',
        path: '/inventory-management/stock-movement-details',
        element: lazy(() => import('../pages/inventory/StockMovementDetailsPage')),
        description: 'View detailed stock movement records',
    },
    {
        label: 'Alerts & Notifications',
        path: '/inventory-management/alerts',
        element: lazy(() => import('../pages/inventory/InventoryAlertsPage')),
        description: 'Manage inventory alerts',
    },
    {
        label: 'Stock Analytics',
        path: '/inventory-management/stock-analytics',
        element: lazy(() => import('../pages/inventory/StockAnalyticsPage')),
        description: 'Analyze stock trends and patterns',
    },
    {
        label: 'Supplier Performance',
        path: '/inventory-management/supplier-performance',
        element: lazy(() => import('../pages/inventory/SupplierPerformancePage')),
        description: 'Monitor supplier performance metrics',
    },
    {
        label: 'Export Reports',
        path: '/inventory-management/export',
        element: lazy(() => import('../pages/inventory/ExportReportsPage')),
        description: 'Export inventory reports',
    },
    // {
    //   label: 'Dashboard',
    //   path: '/dashboard',
    //   element: lazy(() => import('../pages/Dashboard')),
    // },
    // j
    // {
    //   label: 'User',
    //   subItems: [
    //     {
    //       label: 'Create',
    //       path: '/user/create',
    //       element: lazy(() => import('../pages/User/CreateUserPage')),
    //     },
    //     {
    //       label: 'Form Layouts',
    //       path: '/forms/layouts',
    //       element: lazy(() => import('../pages/Dashboard')),
    //     },
    //   ],
    //   element: lazy(() => import('../pages/User/UserPage')),
    // },
    // {
    //   label: 'Client',
    //
    //   subItems: [
    //     {
    //       label: 'Create',
    //       path: '/client/create',
    //       element: lazy(() => import('../pages/Client/CreateClientPage')),
    //     },
    //   ],
    // },
    {
        label: 'IoT Dashboard',
        path: '/iot-dashboard',
        element: lazy(() => import('../pages/DashboardPage')),
        hidden: true,
    },
    {
        label: 'Create Device', // Label used for potential breadcrumbs, etc.
        path: '/device/create', // The path used in useNavigate
        element: lazy(() => import('../pages/Device/CreateDevicePage')),
        hidden: true, // Add this if you DON'T want it to appear in generated sidebars/menus
    },
    {
        label: 'Edit Device', // Label for breadcrumbs etc.
        path: '/device/edit/:deviceId', // Dynamic route with deviceId parameter
        element: lazy(() => import('../pages/Device/EditDevicePage')), // Point to the new Edit page component
        hidden: true, // Usually hidden from main navigation
    },
    {
        label: 'Create Production Line',
        path: '/device-group/create',
        element: lazy(() => import('../pages/DeviceGroup/CreateDeviceGroupPage')),
        hidden: true,
    },
    {
        label: 'Edit Production Line',
        path: '/device-group/edit/:deviceGroupId',
        element: lazy(() => import('../pages/DeviceGroup/EditDeviceGroupPage')),
        hidden: true,
    },
    {
        label: 'Device Analytics',
        path: '/device/analytics/:deviceId',
        element: lazy(() => import('../pages/Device/DeviceAnalyticsPage')),
        hidden: true,
    },
    {
        label: 'Production Line Analytics',
        path: '/device-group/analytics/:deviceGroupId',
        element: lazy(() => import('../pages/DeviceGroup/DeviceGroupAnalyticsPage')),
        hidden: true,
    },
    {
        label: 'Sensor Statistics',
        path: '/device/analytics/:deviceId/sensor/:sensorName',
        element: lazy(() => import('../pages/Sensor/SensorStatisticsPage')),
        hidden: true,
    },
    {
        label: 'Production Line OEE Detail',
        path: '/devicegroup/oee/:deviceGroupId',
        element: lazy(() => import('../pages/DeviceGroupOeeDetailPage')),
        hidden: true,
    },
    {
        label: 'Create OEE Quality',
        path: '/manual-count/create',
        element: lazy(() => import('../pages/ManualCount/CreateOEEQualityPage')),
        hidden: true,
    },
    {
        label: 'Edit OEE Quality',
        path: '/manual-count/edit/:id',
        element: lazy(() => import('../pages/ManualCount/CreateOEEQualityPage')),
        hidden: true,
    },
    {
        label: 'Production Output CSV Import',
        path: '/manual-count/production-output-csv-import',
        element: lazy(() => import('../pages/ManualCount/OEEQualityCSVImportPage')),
        hidden: true,
    },
];
